import Styles from './InfoForNodes.module.scss'
import { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useAPI } from 'components/lib';
import { NodeInfoLayout } from 'components/global/nodeInfoLayout/NodeInfoLayout';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { InstructionsView } from '../../Global/InstructionsView/InstructionsView';

export function InfoForNodes(props) {

    const { node_id } = useParams();
    const { lab_id } = useParams();

    const { data, loading } = useAPI(`/api/labs/${lab_id}/nodes/${node_id}/nodeinfo`, 'GET')

    const [nodeInfo, setNodeInfo] = useState([]);
    useEffect(() => {
        if (data?.nodeInfo) {
            setNodeInfo(data.nodeInfo);
        }
    }, [data])

    const instructionsRef = useRef(null);

    const scrollToInstructions = () => {
        instructionsRef.current.scrollIntoView({ behavior: 'smooth' });
    }

    return (
        <>
            <div id='ancestorContainer' className={Styles.CardContainer}>
                {loading ? (
                    <div>
                        <LoadingBackdrop isOpen={true} />
                    </div>
                ) : (
                    nodeInfo?.length > 0 ? (
                        <>
                            <NodeInfoLayout
                                name={nodeInfo[0].name}
                                image={nodeInfo[0].icon}
                                goals={nodeInfo[0].goal}
                                descr={nodeInfo[0].descr}
                                subtitle={nodeInfo[0].subtitle}
                                video={nodeInfo[0].video_link}
                                isAssessment={nodeInfo[0].is_assessment}
                                startButton={scrollToInstructions}
                                t={props.t}
                            />
                            <span className={Styles.instructionsSpreader}>
                                <InstructionsView
                                    instructionsRef={instructionsRef}
                                    data={data}
                                    loading={loading}
                                    t={props.t}
                                />
                            </span>
                        </>
                    ) : props.t('Labs.InfoForNodes.none')
                )}
            </div>
        </>
    );
}